var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center alert alert-danger fs-2"},[_c('i',{staticClass:"fa fa-times-circle"}),_vm._v(" Oops. Access Denied 403 ")])])
}]

export { render, staticRenderFns }